import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  OnChanges,
  ViewChildren,
  QueryList,
  ElementRef,
  ViewChild
} from '@angular/core';
import { Activity, ActivityModel } from '../../../models/activities';
import { ActivityNavigationInfo } from '../../../models/activity-navigation-Info';
import { Router } from '@angular/router';
import { WorkflowContextService } from 'src/app/services';
import { LayoutService } from 'src/app/services/layout.service';
import { WorkflowApplicationsJanusService } from 'src/app/views/admin/workflow-applications/workflow-applications-janus/workflow-applications-janus.service';

@Component({
    selector: 'wm-workflow-application-navigation',
    templateUrl: './workflow-application-navigation.component.html',
    styleUrls: ['./workflow-application-navigation.component.css'],
    standalone: false
})
export class WorkflowApplicationNavigationComponent
  implements OnInit, OnChanges {
  @Input() currentActivity: Activity<ActivityModel>;
  @Input() applicationId: string;
  @Input() navigationItems: ActivityNavigationInfo[];
  @Output() onNavigate: EventEmitter<string> = new EventEmitter<string>();
  @Output() switchApplication: EventEmitter<string> = new EventEmitter<
    string
  >();
  //added by priya 2025-11-12
  @ViewChildren('stepElem') stepElems!: QueryList<ElementRef>;
  @ViewChild('wizardSteps') wizardStepsRef!: ElementRef;

@Output() stepClicked = new EventEmitter<void>();//Added by Priya on 26-08-2026 forScroll Activity Stepper to top when navigating between activities.

scrollToActiveStep() {
  setTimeout(() => {
    if (!this.currentActivity || !this.currentNavigationItems || !this.stepElems) {
      return;
    }
    const activeIndex = this.currentNavigationItems.findIndex(
      ni => ni.activityDataId === this.currentActivity.activityDataId
    );

    if (activeIndex === -1) {
      return;
    }

    const activeStep = this.stepElems.toArray()[activeIndex]?.nativeElement;
    const container = this.wizardStepsRef?.nativeElement;

    if (!activeStep || !container) {
      return;
    }

    const scrollTop =
      activeStep.offsetTop -
      container.clientHeight / 2 +
      activeStep.clientHeight / 2;

    container.scrollTo({
      top: scrollTop,
      behavior: 'smooth'
    });
  },1000);
}


  //end by priya 2025-11-12

  loading = false;
  hasEmailsToDisplay = false;
  showEmails = false;
  currentNavigationItems: ActivityNavigationInfo[];

  emailActivityTypeCodes = [
    'email-activity',
    'schedule-email-activity',
    'appointment-activity'
  ];
  templateForPermitForm = false;

  constructor(   public layoutService: LayoutService,
    private _router: Router,
    public context: WorkflowContextService,
    public workflowApplicationsJanusSvc : WorkflowApplicationsJanusService
  ) {

    layoutService.useNewLayout$.subscribe((useNewLayout) => {
      this.templateForPermitForm = useNewLayout;
    });
  }


    //   //added by priya 2025-11-12

    // getStepStatus(ni: ActivityNavigationInfo, index: number): 'active' | 'completed' | 'upcoming' {
    //   const activeIndex = this.currentNavigationItems.findIndex(
    //     item => item.activityId === this.currentActivity.id
    //   );

    //   if (index === activeIndex) return 'active';
    //   if (index < activeIndex) return 'completed';
    //   return 'upcoming';
    // }
    //   //end by priya 2025-11-12

        //Deepak 05/27/2026: Updated getStepStatus to not completed activity dont show as completed in navigation and only show as completed when activity is completed in backend.
  getStepStatus(
        ni: ActivityNavigationInfo,
        index: number
      ): 'active' | 'completed' | 'upcoming' {

        if (this.currentActivity && ni.activityDataId === this.currentActivity.activityDataId) {
          return 'active';
        }

        if (ni.completed) {
          return 'completed';
        }

        return 'upcoming';
      }

  // End by Deepak 05/27/2026

  navigate(ni: ActivityNavigationInfo) {
    this.workflowApplicationsJanusSvc.setData({
        ...this.workflowApplicationsJanusSvc.getData(),
        scrollToExpandedRow: true
      });
    const activityDataId = ni.activityDataId;
    const applicationId = ni.applicationId;
    if (ni.canNavigate) {
      if (applicationId) {
        this.switchApplication.emit(applicationId);
      } else if (
        activityDataId &&
        this.currentActivity &&
        activityDataId !== this.currentActivity.activityDataId
      ) {
        this.onNavigate.emit(activityDataId);
        return true;
      }
    }

    return false;
  }

  // isActive(activity) {
  //   return activity.activityId === this.currentActivity.id;
  // }
isActive(activity: ActivityNavigationInfo): boolean {

  return !!activity &&
         !!this.currentActivity &&
         activity.activityId === this.currentActivity.id;
}

  ngOnInit() {


    this.checkForEmails();
    this.setCurrentNavigationItems();
  }

  ngOnChanges(changes: SimpleChanges) {
      //added by priya 2025-11-12

    if (changes.currentActivity && !changes.currentActivity.firstChange) {
    if(this.templateForPermitForm){
        this.scrollToActiveStep();
      }
    }
    //end by priya 2025-11-12

    if (changes.navigationItems) {
      this.checkForEmails();
      this.setCurrentNavigationItems();
    }
  }

  getTooltip(item: ActivityNavigationInfo) {
    return item.activityRole ? `Role: ${item.activityRole}` : null;
  }

  navClass(item: ActivityNavigationInfo) {
    if (!item.activityColor) {
      return;
    }

    return {
      ['rc-' + item.activityColor]: this.isActive(item),
      ['rc-border-' + item.activityColor]: !this.isActive(item)
    };
  }

  checkForEmails() {
    this.hasEmailsToDisplay =
      this.navigationItems.filter(ni =>
        this.emailActivityTypeCodes.includes(ni.activityType)
      ).length > 0;
  }


  setCurrentNavigationItems() {
    if(this.context?.useNewLayout === true && this.context?.isJanusChildWorkflowCalled === true){
      this.currentNavigationItems = this.showEmails
            ? this.navigationItems
            : this.navigationItems.filter(
                ni => !this.emailActivityTypeCodes.includes(ni.activityType)
              )
              .filter(ni => !ni?.applicationId)
    }else{
      this.currentNavigationItems = this.showEmails
            ? this.navigationItems
            : this.navigationItems.filter(
                ni => !this.emailActivityTypeCodes.includes(ni.activityType)
              );
    }
      if(this.templateForPermitForm){
        this.scrollToActiveStep();
      }
    }
    //added by priya on 26-08-2026
 onStepClick(ni: any) {
  this.navigate(ni);
  this.stepClicked.emit();
}

}
